module.exports = __webpack_public_path__ + "img/bg-fun.a57711ee.svg";